/* ==========================================================================
   Aquí Estamos PY — Flujo de reserva en 5 pasos
   Web Component <ae-reserva>.

   Paso 1  Configuración del servicio  (reutiliza <ae-cotizador data-embebido>)
   Paso 2  Fecha y turno               (calendario propio, sin dependencias)
   Paso 3  Localización
   Paso 4  Datos del cliente y facturación
   Paso 5  Confirmación

   No hay cobro con tarjeta. Según `data-modo`:
     · "contacto" → envía el formulario de contacto de Shopify (+ webhook opcional)
     · "checkout" → arma el carrito con line item properties y va a /checkout,
                    donde se cobra con un método de pago manual (transferencia).
   ========================================================================== */
(function () {
  'use strict';

  var AE = window.AE || {};
  var CFG = (AE.config && AE.config.reserva) || {};
  var CLAVE_OK = 'ae_reserva_ok';

  var proto = {
    connectedCallback: function () {
      if (this._listo) return;
      this._listo = true;

      this.modo = this.getAttribute('data-modo') || CFG.modo || 'contacto';
      this.pasoActual = 1;

      // El {% form 'contact' %} de Shopify envuelve al componente, así que se
      // busca primero adentro y si no, el <form> ancestro.
      this.form = AE.$('[data-reserva-form]', this) || this.closest('form');
      this.paneles = AE.$$('[data-paso]', this);
      this.stepperItems = AE.$$('[data-stepper-item]', this);
      this.cotizador = AE.$('ae-cotizador', this);
      this.nodoCal = AE.$('[data-cal]', this);
      this.nodoError = AE.$('[data-reserva-error]', this);

      this.presupuesto = null;
      this.fecha = '';

      this.enlazar();
      this.initCalendario();

      // ae-cotizador se define antes que ae-reserva, así que ya emitió su
      // evento inicial cuando llegamos acá. Se toma el estado directamente
      // para que el resumen lateral no arranque vacío.
      if (this.cotizador && typeof this.cotizador.serializar === 'function') {
        this.presupuesto = this.cotizador.serializar();
        this.pintarResumenLateral();
        this.ajustarPaso2();
      }

      this.mostrarPaso(1, false);
    },

    /* --------------------------------------------------------- Eventos */

    enlazar: function () {
      var self = this;

      this.addEventListener('ae:cotizacion', function (ev) {
        self.presupuesto = ev.detail;
        self.pintarResumenLateral();
        self.ajustarPaso2();
      });

      this.addEventListener('click', function (ev) {
        var sig = ev.target.closest('[data-siguiente]');
        if (sig) {
          ev.preventDefault();
          if (self.validarPaso(self.pasoActual)) self.mostrarPaso(self.pasoActual + 1);
          return;
        }
        var atras = ev.target.closest('[data-atras]');
        if (atras) {
          ev.preventDefault();
          self.mostrarPaso(self.pasoActual - 1);
          return;
        }
        var ir = ev.target.closest('[data-ir-paso]');
        if (ir) {
          ev.preventDefault();
          var destino = parseInt(ir.getAttribute('data-ir-paso'), 10);
          if (destino < self.pasoActual) self.mostrarPaso(destino);
        }
      });

      // Limpiar el estado de error al corregir un campo
      this.addEventListener('input', function (ev) {
        var campo = ev.target.closest('.field');
        if (campo) campo.classList.remove('is-invalid');
      });

      // El clic se escucha siempre: en modo checkout no hay <form> alrededor,
      // y si lo hubiera, cortar el clic evita cualquier envio nativo.
      this.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-enviar]')) self.enviar(ev);
      });

      // Factura: mostrar los dos campos y reutilizar el correo del paso 4.
      var toggle = AE.$('[data-factura-toggle]', this);
      if (toggle) {
        toggle.addEventListener('change', function () { self.alternarFactura(); });
      }

      if (this.form) {
        this.form.addEventListener('submit', function (ev) { self.enviar(ev); });
      }
    },

    /**
     * Con plan fijo la fecha del calendario no es «la» fecha del servicio,
     * sino la del primero: el resto se repite en los días elegidos. Cambiar
     * el rótulo evita que el cliente crea que sólo reservó ese día.
     */
    ajustarPaso2: function () {
      var p = this.presupuesto;
      if (!p) return;
      var fijo = !!(p.dias && p.dias.length);

      var rotulo = AE.$('[data-label-fecha]', this);
      if (rotulo) rotulo.textContent = fijo ? 'Fecha del primer servicio' : 'Fecha del servicio';

      var nota = AE.$('[data-nota-recurrencia]', this);
      if (nota) {
        nota.hidden = !fijo;
        if (fijo) {
          nota.textContent = 'A partir de esa fecha el servicio se repite todas las semanas: ' +
            p.diasTexto + '.';
        }
      }
    },

    /* ---------------------------------------------------- Navegación */

    mostrarPaso: function (n, desplazar) {
      var total = this.paneles.length;
      n = Math.min(Math.max(n, 1), total);
      this.pasoActual = n;

      this.paneles.forEach(function (p) {
        p.hidden = parseInt(p.getAttribute('data-paso'), 10) !== n;
      });

      this.stepperItems.forEach(function (item) {
        var i = parseInt(item.getAttribute('data-stepper-item'), 10);
        item.classList.toggle('is-active', i === n);
        item.classList.toggle('is-done', i < n);
      });

      // Al llegar al último paso se refresca el eco del correo, por si el
      // cliente volvió atrás y lo cambió.
      if (n === total) { this.pintarConfirmacion(); this.alternarFactura(); }

      if (desplazar !== false) {
        var top = this.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    },

    /**
     * Muestra u oculta los campos de factura. El correo no se vuelve a pedir:
     * se toma el del paso 4 y se enseña para que el cliente lo confirme.
     * Los campos sólo son obligatorios mientras están a la vista, por eso el
     * data-required se pone y se saca en lugar de vivir en el marcado.
     */
    alternarFactura: function () {
      var toggle = AE.$('[data-factura-toggle]', this);
      var caja = AE.$('[data-factura-campos]', this);
      if (!toggle || !caja) return;

      var quiere = toggle.checked;
      caja.hidden = !quiere;

      var eco = AE.$('[data-factura-email]', this);
      if (eco) eco.value = this.valor('email');

      ['razon_social', 'ruc_factura'].forEach(function (nombre) {
        var campo = AE.$('[data-campo-nombre="' + nombre + '"]', this);
        if (!campo) return;
        if (quiere) {
          campo.setAttribute('data-required', '');
        } else {
          campo.removeAttribute('data-required');
          campo.value = '';
          var cont = campo.closest('.field');
          if (cont) cont.classList.remove('is-invalid');
        }
      }, this);
    },

    /* --------------------------------------------------- Validación */

    validarPaso: function (n) {
      var panel = this.paneles.filter(function (p) {
        return parseInt(p.getAttribute('data-paso'), 10) === n;
      })[0];
      if (!panel) return true;

      var ok = true;
      var primero = null;

      // Paso 1: días de la semana y turno son reglas del cotizador, que es
      // quien las conoce. Delegar evita duplicar la lógica acá.
      if (n === 1 && this.cotizador && typeof this.cotizador.validar === 'function') {
        if (!this.cotizador.validar()) return false;
      }

      // Se usa `data-required` en lugar del atributo nativo: los paneles
      // ocultos siguen siendo validados por el navegador y bloquearían el
      // envío con un error no enfocable.
      AE.$$('[data-required]', panel).forEach(function (campo) {
        if (campo.disabled) return;
        var valido = campo.type === 'radio'
          ? !!panel.querySelector('input[name="' + campo.name + '"]:checked')
          : String(campo.value || '').trim() !== '';

        if (valido && campo.type === 'email') {
          valido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(campo.value.trim());
        }
        if (valido && campo.hasAttribute('data-min-length')) {
          valido = campo.value.trim().length >= parseInt(campo.getAttribute('data-min-length'), 10);
        }

        var contenedor = campo.closest('.field') || campo.closest('[data-campo]');
        if (contenedor) contenedor.classList.toggle('is-invalid', !valido);
        if (campo.setAttribute) campo.setAttribute('aria-invalid', valido ? 'false' : 'true');

        if (!valido) {
          ok = false;
          if (!primero) primero = campo;
        }
      });

      // Paso 2: la fecha vive en un input oculto alimentado por el calendario
      if (n === 2 && !this.fecha) {
        var aviso = AE.$('[data-cal-error]', panel);
        if (aviso) aviso.hidden = false;
        ok = false;
        if (!primero) primero = this.nodoCal;
      } else if (n === 2) {
        var aviso2 = AE.$('[data-cal-error]', panel);
        if (aviso2) aviso2.hidden = true;
      }

      if (!ok && primero && primero.focus) {
        primero.focus({ preventScroll: true });
        primero.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      return ok;
    },

    /* --------------------------------------------------- Calendario */

    initCalendario: function () {
      if (!this.nodoCal) return;

      var hoy = AE.hoy();
      this.minFecha = new Date(hoy);
      this.minFecha.setDate(this.minFecha.getDate() + (Number(CFG.anticipacionDias) || 0));

      this.mesVisible = new Date(this.minFecha.getFullYear(), this.minFecha.getMonth(), 1);
      this.inputFecha = AE.$('[data-input-fecha]', this);

      var self = this;
      this.nodoCal.addEventListener('click', function (ev) {
        var nav = ev.target.closest('[data-cal-nav]');
        if (nav) {
          var paso = parseInt(nav.getAttribute('data-cal-nav'), 10);
          self.mesVisible = new Date(self.mesVisible.getFullYear(), self.mesVisible.getMonth() + paso, 1);
          self.renderCalendario();
          return;
        }
        var dia = ev.target.closest('[data-fecha]');
        if (dia && !dia.disabled) {
          self.fecha = dia.getAttribute('data-fecha');
          if (self.inputFecha) self.inputFecha.value = self.fecha;
          var aviso = AE.$('[data-cal-error]', self);
          if (aviso) aviso.hidden = true;
          self.renderCalendario();
          self.pintarResumenLateral();
        }
      });

      this.renderCalendario();
    },

    diaBloqueado: function (d) {
      if (d < this.minFecha) return true;
      if (CFG.bloquearDomingos && d.getDay() === 0) return true;
      return false;
    },

    renderCalendario: function () {
      var mes = this.mesVisible.getMonth();
      var anio = this.mesVisible.getFullYear();
      var primerDia = new Date(anio, mes, 1).getDay();
      var diasEnMes = new Date(anio, mes + 1, 0).getDate();
      var hoyISO = AE.aISO(AE.hoy());

      // ¿Se puede retroceder? Nunca antes del mes de la fecha mínima.
      var puedeAtras = new Date(anio, mes, 1) > new Date(this.minFecha.getFullYear(), this.minFecha.getMonth(), 1);

      var html = '';
      html += '<div class="cal__head">';
      html += '<button type="button" class="cal__nav" data-cal-nav="-1" aria-label="Mes anterior"' + (puedeAtras ? '' : ' disabled') + '>';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>';
      html += '<span class="cal__mes">' + AE.MESES[mes] + ' ' + anio + '</span>';
      html += '<button type="button" class="cal__nav" data-cal-nav="1" aria-label="Mes siguiente">';
      html += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>';
      html += '</div>';

      html += '<div class="cal__dias" aria-hidden="true">';
      AE.DIAS_CORTOS.forEach(function (d) { html += '<span>' + d + '</span>'; });
      html += '</div>';

      html += '<div class="cal__grid" role="group" aria-label="Elegí el día del servicio">';
      for (var i = 0; i < primerDia; i++) {
        html += '<span class="cal__dia is-empty"></span>';
      }
      for (var dia = 1; dia <= diasEnMes; dia++) {
        var d = new Date(anio, mes, dia);
        var iso = AE.aISO(d);
        var bloqueado = this.diaBloqueado(d);
        var clases = 'cal__dia';
        if (iso === this.fecha) clases += ' is-selected';
        if (iso === hoyISO) clases += ' is-hoy';
        html += '<button type="button" class="' + clases + '" data-fecha="' + iso + '"' +
          (bloqueado ? ' disabled' : '') +
          ' aria-label="' + AE.esc(AE.fechaLarga(iso)) + '"' +
          (iso === this.fecha ? ' aria-current="date"' : '') +
          '>' + dia + '</button>';
      }
      html += '</div>';

      html += '<div class="cal__leyenda">';
      html += '<span><i style="background:var(--navy)"></i>Día elegido</span>';
      html += '<span><i style="background:var(--gris-200)"></i>Disponible</span>';
      if (CFG.bloquearDomingos) html += '<span><i style="background:transparent;border:1px solid var(--gris-400)"></i>No trabajamos domingos</span>';
      html += '</div>';

      this.nodoCal.innerHTML = html;
    },

    /* ---------------------------------------------- Resumen lateral */

    pintarResumenLateral: function () {
      var caja = AE.$('[data-resumen-reserva]', this);
      if (!caja || !this.presupuesto) return;

      var p = this.presupuesto;
      var turno = this.turnoElegido();
      var html = '';

      html += this.filaResumen('Modalidad', p.planLabel);
      html += this.filaResumen('Duración', p.horas + ' horas');
      if (p.dias && p.dias.length) {
        html += this.filaResumen(
          p.dias.length === 1 ? 'Día' : 'Días',
          p.diasCorto + ' (' + p.dias.length + (p.dias.length === 1 ? ' por semana)' : ' servicios por semana)')
        );
      }
      if (p.extrasDetalle.length) {
        html += this.filaResumen('Adicionales', p.extrasDetalle.map(function (e) { return e.nombre; }).join(', '));
      }
      if (this.fecha) html += this.filaResumen('Fecha', AE.fechaLarga(this.fecha));
      if (turno) html += this.filaResumen('Turno', turno);

      caja.innerHTML = html;

      var total = AE.$('[data-resumen-reserva-total]', this);
      if (total) total.textContent = AE.gs(p.total);

      // Ver la nota en ae-cotizador.js: el importe es por servicio.
      var rotulo = AE.$('[data-total-label]', this);
      if (rotulo) {
        rotulo.textContent = (p.dias && p.dias.length > 1) ? 'Total por servicio' : 'Total';
      }
    },

    filaResumen: function (k, v) {
      return '<div class="row"><dt>' + AE.esc(k) + '</dt><dd>' + AE.esc(v) + '</dd></div>';
    },

    /* -------------------------------------------------- Recolección */

    /**
     * El turno se elige en el paso 1, dentro del cotizador: es donde está la
     * cantidad de horas, y la regla depende de ella (6 y 8 horas no llevan
     * turno). Antes vivía en el paso 2 y se podía quedar un turno marcado
     * después de cambiar a 8 horas.
     */
    turnoElegido: function () {
      var p = this.presupuesto;
      if (p) return p.turnoLabel || '';
      if (this.cotizador && this.cotizador.turnoTexto) return this.cotizador.turnoTexto();
      return '';
    },

    valor: function (nombre) {
      var el = AE.$('[data-campo-nombre="' + nombre + '"]', this);
      return el ? String(el.value || '').trim() : '';
    },

    datos: function () {
      var p = this.presupuesto || (this.cotizador && this.cotizador.serializar()) || {};
      return {
        plan: p.plan,
        planLabel: p.planLabel,
        horas: p.horas,
        dias: p.dias || [],
        diasTexto: p.diasTexto || '',
        diasCorto: p.diasCorto || '',
        serviciosPorSemana: p.serviciosPorSemana || 0,
        jornadaCompleta: !!p.jornadaCompleta,
        extras: (p.extrasDetalle || []).map(function (e) { return e.nombre; }),
        extrasDetalle: p.extrasDetalle || [],
        base: p.base,
        totalExtras: p.totalExtras,
        total: p.total,
        totalFormateado: AE.gs(p.total),
        fecha: this.fecha,
        fechaLarga: AE.fechaLarga(this.fecha),
        turno: this.turnoElegido(),
        ciudad: this.valor('ciudad'),
        barrio: this.valor('barrio'),
        nombre: this.valor('nombre'),
        documento: this.valor('documento'),
        telefono: this.valor('telefono'),
        email: this.valor('email'),
        direccion: this.valor('direccion'),
        referencias: this.valor('referencias'),
        factura: !!(AE.$('[data-factura-toggle]', this) || {}).checked,
        razonSocial: this.valor('razon_social'),
        rucFactura: this.valor('ruc_factura'),
        enviadoEn: new Date().toISOString()
      };
    },

    resumenTexto: function (d) {
      var l = [];
      l.push('NUEVA RESERVA — Aquí Estamos');
      l.push('');
      l.push('Modalidad: ' + d.planLabel);
      l.push('Duración: ' + d.horas + ' horas');
      if (d.diasTexto) {
        l.push('Días de la semana: ' + d.diasTexto + ' (' + d.serviciosPorSemana + ' por semana)');
      }
      l.push('Adicionales: ' + (d.extras.length ? d.extras.join(', ') : 'ninguno'));
      l.push(d.diasTexto ? 'Primer servicio: ' + d.fechaLarga : 'Fecha: ' + d.fechaLarga);
      l.push('Turno: ' + d.turno);
      l.push('Ciudad: ' + d.ciudad + (d.barrio ? ' — ' + d.barrio : ''));
      l.push('Dirección: ' + d.direccion);
      if (d.referencias) l.push('Referencias: ' + d.referencias);
      l.push('');
      l.push('Cliente: ' + d.nombre);
      l.push('RUC / CI: ' + d.documento);
      l.push('Teléfono: ' + d.telefono);
      l.push('Correo: ' + d.email);
      l.push('');
      if (d.factura) {
        l.push('');
        l.push('FACTURA');
        l.push('Razón social: ' + d.razonSocial);
        l.push('RUC: ' + d.rucFactura);
        l.push('Enviar a: ' + d.email);
      }
      l.push('');
      l.push('TOTAL: ' + d.totalFormateado);
      l.push('Pago: transferencia bancaria (sin cobro online).');
      return l.join('\n');
    },

    /* ------------------------------------------------- Confirmación */

    pintarConfirmacion: function () {
      var caja = AE.$('[data-confirmacion-resumen]', this);
      if (!caja) return;

      var d = this.datos();
      var html = '';
      html += this.filaResumen('Modalidad', d.planLabel);
      html += this.filaResumen('Duración', d.horas + ' horas');
      if (d.diasTexto) {
        html += this.filaResumen('Días de la semana', d.diasTexto);
      }
      html += this.filaResumen('Adicionales', d.extras.length ? d.extras.join(', ') : 'Ninguno');
      html += this.filaResumen(d.diasTexto ? 'Primer servicio' : 'Fecha', d.fechaLarga);
      html += this.filaResumen('Turno', d.turno);
      html += this.filaResumen('Localización', d.ciudad + (d.barrio ? ' — ' + d.barrio : ''));
      html += this.filaResumen('Dirección', d.direccion);
      html += this.filaResumen('A nombre de', d.nombre + ' (' + d.documento + ')');
      html += this.filaResumen('Contacto', d.telefono + ' · ' + d.email);
      caja.innerHTML = html;

      var total = AE.$('[data-confirmacion-total]', this);
      if (total) total.textContent = AE.gs(d.total);

      var rotuloFinal = AE.$('[data-total-label-final]', this);
      if (rotuloFinal) {
        rotuloFinal.textContent = (d.dias && d.dias.length > 1)
          ? 'Total por servicio'
          : 'Total a abonar';
      }
    },

    /* ------------------------------------------------------- Envío */

    enviar: function (ev) {
      // Segunda vuelta: los campos ocultos ya están completos y nosotros
      // mismos pedimos el envío nativo. Hay que dejar que el evento `submit`
      // siga su curso, porque es ahí donde Shopify engancha su protección
      // anti-spam para adjuntar el token del CAPTCHA.
      if (this._nativo) return;

      ev.preventDefault();
      // clic y submit pueden llegar los dos: se procesa una sola vez
      if (this._enviando) return;

      // Revalidar todos los pasos con campos antes de enviar.
      for (var n = 1; n <= this.paneles.length; n++) {
        if (!this.validarPaso(n)) { this.mostrarPaso(n); return; }
      }

      var self = this;
      var d = this.datos();
      var btn = AE.$('[data-enviar]', this);

      this._enviando = true;
      this.bloquear(btn, true);
      if (this.nodoError) this.nodoError.hidden = true;

      // Guardar para poder mostrar el detalle después de la recarga.
      try { sessionStorage.setItem(CLAVE_OK, JSON.stringify(d)); } catch (e) { /* noop */ }

      var webhook = AE.enviarWebhook({ tipo: 'reserva', datos: d });

      if (this.modo === 'checkout') {
        webhook.then(function () { return self.enviarPorCheckout(d); })
          .catch(function (err) { self.fallo(err, btn); });
      } else {
        webhook.then(function () { self.enviarPorContacto(d); })
          .catch(function () { self.enviarPorContacto(d); });
      }
    },

    /** Modo "contacto": completa los campos ocultos y hace POST a /contact. */
    enviarPorContacto: function (d) {
      var mapa = {
        'contact[name]': d.nombre,
        'contact[email]': d.email,
        'contact[phone]': d.telefono,
        'contact[Modalidad]': d.planLabel,
        'contact[Duracion]': d.horas + ' horas',
        'contact[Dias_Semana]': d.diasTexto || 'No aplica (servicio puntual)',
        'contact[Adicionales]': d.extras.length ? d.extras.join(', ') : 'Ninguno',
        'contact[Fecha_Reserva]': d.fechaLarga + ' (' + d.fecha + ')',
        'contact[Turno_Reserva]': d.turno,
        'contact[Ciudad]': d.ciudad,
        'contact[Barrio]': d.barrio,
        'contact[Direccion]': d.direccion,
        'contact[Referencias]': d.referencias,
        'contact[RUC_CI]': d.documento,
        'contact[Factura]': d.factura ? 'Sí' : 'No',
        'contact[Razon_Social]': d.factura ? d.razonSocial : '',
        'contact[RUC_Factura]': d.factura ? d.rucFactura : '',
        'contact[Total_Presupuesto]': d.totalFormateado,
        'contact[body]': this.resumenTexto(d)
      };

      for (var nombre in mapa) {
        if (!Object.prototype.hasOwnProperty.call(mapa, nombre)) continue;
        var input = this.form.querySelector('[name="' + nombre.replace(/([[\]])/g, '\\$1') + '"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = nombre;
          this.form.appendChild(input);
        }
        input.value = mapa[nombre];
      }

      // Shopify adjunta el token del CAPTCHA escuchando el evento `submit`
      // del formulario, igual que hace con el de Empresas. form.submit() no
      // dispara ese evento, así que el POST llegaba sin token y Shopify lo
      // rechazaba con «Missing CAPTCHA token». requestSubmit() sí lo dispara;
      // el guardia _nativo deja pasar esa segunda vuelta sin reprocesarla.
      this._nativo = true;
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        // Safari anterior a 16: se emula el evento y, si nadie lo cancela
        // (es decir, si no hay protección anti-spam), se envía a mano.
        var evento = new Event('submit', { bubbles: true, cancelable: true });
        if (this.form.dispatchEvent(evento)) {
          HTMLFormElement.prototype.submit.call(this.form);
        }
      }
    },

    /**
     * Modo "checkout": arma el carrito con line item properties y redirige.
     * El cobro se completa con un método de pago manual (transferencia).
     */
    enviarPorCheckout: function (d) {
      var self = this;
      // En el editor de temas Shopify bloquea las operaciones de carrito:
      // conviene decirlo en vez de mostrar un error críptico.
      if (window.Shopify && window.Shopify.designMode) {
        return Promise.reject(new Error(
          'No se puede completar una reserva desde el editor de temas. ' +
          'Abrí la vista previa de la tienda en una pestaña normal y probá de nuevo.'
        ));
      }

      var variantes = (AE.config.variantes || {})[d.plan] || {};
      var idBase = variantes[String(d.horas)];

      if (!idBase) {
        return Promise.reject(new Error(
          'Falta configurar el ID de variante para ' + d.planLabel + ' de ' + d.horas + ' horas ' +
          '(Configuración del tema → Checkout con pago manual).'
        ));
      }

      // Propiedades ocultas (guion bajo) pedidas por especificación + copias
      // visibles para que el cliente y el equipo las vean en el pedido.
      var props = {
        '_Fecha_Reserva': d.fecha,
        '_Turno_Reserva': d.turno,
        '_Dias_Semana': d.dias.join(','),
        'Fecha del servicio': d.fechaLarga,
        'Turno': d.turno,
        'Modalidad': d.planLabel + (d.diasTexto ? ' · ' + d.diasCorto : ''),
        'Ciudad': d.ciudad + (d.barrio ? ' — ' + d.barrio : ''),
        'Dirección': d.direccion,
        'Referencias': d.referencias || '—',
        'RUC / CI': d.documento,
        'Teléfono': d.telefono
      };

      var items = [{ id: Number(idBase), quantity: 1, properties: props }];

      d.extrasDetalle.forEach(function (e) {
        if (e.variante) {
          items.push({
            id: Number(e.variante),
            quantity: 1,
            properties: { '_Fecha_Reserva': d.fecha, 'Fecha del servicio': d.fechaLarga, 'Turno': d.turno }
          });
        }
      });

      var atributos = {
        'Fecha de reserva': d.fechaLarga,
        'Turno': d.turno,
        'Días de la semana': d.diasTexto || 'No aplica',
        'Ciudad': d.ciudad,
        'Modalidad': d.planLabel,
        'RUC / CI': d.documento,
        'Forma de pago': 'Transferencia bancaria',
        'Factura': d.factura ? 'Sí' : 'No',
        'Razón social': d.factura ? d.razonSocial : '—',
        'RUC de facturación': d.factura ? d.rucFactura : '—',
        'Correo de la reserva': d.email
      };

      var irAlCheckout = function () {
        AE.limpiarPresupuesto();
        window.location.href = '/checkout';
      };

      // Camino clásico: carrito por AJAX. Conserva las propiedades pero el
      // checkout pide el correo de nuevo.
      var porAjax = function () {
        return AE.vaciarCarrito()
          .then(function () { return AE.agregarAlCarrito(items, atributos); })
          .then(irAlCheckout);
      };

      // Camino preferido: enlace permanente con el correo + reposición de las
      // propiedades. Si algo no cuadra se vuelve al camino clásico, porque
      // perder la fecha o el turno del pedido sería mucho peor que pedir el
      // correo dos veces.
      if (!d.email) return porAjax().catch(function (err) { self.fallo(err, AE.$('[data-enviar]', self)); });

      var permalink = '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',') +
        '?checkout%5Bemail%5D=' + encodeURIComponent(d.email);

      return AE.vaciarCarrito()
        .then(function () { return fetch(permalink, { redirect: 'follow' }).catch(function () { return null; }); })
        .then(function () {
          // Reponer las propiedades línea por línea, en el mismo orden.
          return items.reduce(function (cadena, item, i) {
            return cadena.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ line: i + 1, quantity: item.quantity, properties: item.properties })
              });
            });
          }, Promise.resolve());
        })
        .then(function () {
          return fetch((AE.config.routes && AE.config.routes.cartUpdate) || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: atributos })
          });
        })
        .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (carrito) {
          var lineas = (carrito.items || []).length;
          var primera = carrito.items && carrito.items[0];
          var conPropiedades = primera && primera.properties &&
            Object.keys(primera.properties).length > 0;

          if (lineas === items.length && conPropiedades) {
            irAlCheckout();
            return null;
          }
          // El carrito no quedó como debía: se rehace por el camino clásico.
          return porAjax();
        })
        .catch(function () {
          return porAjax().catch(function (err) { self.fallo(err, AE.$('[data-enviar]', self)); });
        });
    },

    fallo: function (err, btn) {
      this._enviando = false;
      this._nativo = false;
      this.bloquear(btn, false);
      if (this.nodoError) {
        this.nodoError.hidden = false;
        this.nodoError.textContent = (err && err.message)
          ? err.message
          : 'No pudimos registrar la reserva. Escribinos por WhatsApp y la agendamos al instante.';
        this.nodoError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },

    bloquear: function (btn, si) {
      if (!btn) return;
      btn.disabled = si;
      if (si) {
        btn.dataset.textoOriginal = btn.textContent;
        btn.textContent = 'Registrando reserva…';
      } else if (btn.dataset.textoOriginal) {
        btn.textContent = btn.dataset.textoOriginal;
      }
    }
  };

  /* ------------------------------------------------------------------------
     Pantalla de éxito tras la recarga de /contact
     ------------------------------------------------------------------------ */
  function pintarExito() {
    var caja = document.querySelector('[data-reserva-exito-detalle]');
    if (!caja) return;

    var d = null;
    try { d = JSON.parse(sessionStorage.getItem(CLAVE_OK) || 'null'); } catch (e) { /* noop */ }
    if (!d) { caja.hidden = true; return; }

    var fila = function (k, v) {
      return '<div class="row"><dt>' + AE.esc(k) + '</dt><dd>' + AE.esc(v) + '</dd></div>';
    };

    caja.innerHTML =
      fila('Servicio', d.horas + ' horas · ' + d.planLabel) +
      (d.diasTexto ? fila('Días de la semana', d.diasTexto) : '') +
      (d.extras && d.extras.length ? fila('Adicionales', d.extras.join(', ')) : '') +
      fila(d.diasTexto ? 'Primer servicio' : 'Fecha', d.fechaLarga) +
      fila('Turno', d.turno) +
      fila('Dirección', d.direccion + ' — ' + d.ciudad) +
      fila('Total a abonar', AE.gs(d.total));
    caja.hidden = false;

    var wa = document.querySelector('[data-reserva-exito-wa]');
    if (wa && AE.waLink) {
      wa.setAttribute('href', AE.waLink(
        'Hola! Acabo de registrar una reserva en la web.\n\n' +
        d.horas + ' horas · ' + d.planLabel + '\n' +
        (d.diasTexto ? d.diasTexto + '\n' : '') +
        d.fechaLarga + ' · ' + d.turno + '\n' +
        d.direccion + ' — ' + d.ciudad + '\n' +
        'Total: ' + AE.gs(d.total) + '\n\n' +
        'Quedo atento/a a los datos bancarios.'
      ));
      wa.hidden = false;
    }

    AE.limpiarPresupuesto();
  }

  /* --------------------------------------------------- Registro del elemento */

  if (window.customElements && !window.customElements.get('ae-reserva')) {
    var El = function () { return Reflect.construct(HTMLElement, [], El); };
    El.prototype = Object.create(HTMLElement.prototype);
    El.prototype.constructor = El;
    Object.assign(El.prototype, proto);
    Object.setPrototypeOf(El, HTMLElement);
    window.customElements.define('ae-reserva', El);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pintarExito);
  } else {
    pintarExito();
  }
})();
